import {
    InfoCircleOutlined,
    LeftOutlined,
    RightOutlined,
} from "@ant-design/icons";
import { FC, ReactNode } from "react";
import { useSwipeable } from "react-swipeable";

import {
    GlobalBottomSheetStyle,
    StyledActionsContainer,
    StyledBody,
    StyledButton,
    StyledInfoButton,
    StyledSheet,
    StyledViewport,
} from "./Styled";

type BottomSheetProps = {
    open: boolean;
    onClose: () => void;
    children: ReactNode;

    onNext?: () => void;
    onPrev?: () => void;

    onClickInfoButton?: () => void;
};

export const BottomSheet: FC<BottomSheetProps> = ({
    open,
    onClose,
    children,
    onNext,
    onPrev,
    onClickInfoButton,
}) => {
    const swipeHandlers = useSwipeable({
        onSwipedDown: onClose,
        trackTouch: true,
        preventScrollOnSwipe: true,
    });

    const actionsSwipeHandlers = useSwipeable({
        onSwipedLeft: onNext,
        onSwipedRight: onPrev,
        trackTouch: true,
        preventScrollOnSwipe: true,
    });
    return (
        <StyledSheet $open={open} {...swipeHandlers}>
            <GlobalBottomSheetStyle />

            <StyledViewport>
                <StyledBody>
                    {onClickInfoButton && (
                        <StyledInfoButton
                            type="text"
                            icon={<InfoCircleOutlined />}
                            onClick={onClickInfoButton}
                        />
                    )}

                    <div>{children}</div>

                    <StyledActionsContainer {...actionsSwipeHandlers}>
                        <StyledButton
                            type="text"
                            icon={<LeftOutlined />}
                            onClick={onPrev}
                            disabled={!onPrev}
                        />
                        <StyledButton
                            type="text"
                            icon={<RightOutlined />}
                            onClick={onNext}
                            disabled={!onNext}
                        />
                    </StyledActionsContainer>
                </StyledBody>
            </StyledViewport>
        </StyledSheet>
    );
};
